/** @mention token in sent message plain text (e.g. @Teja, @Athena). */
const MENTION_TOKEN_RE = /@[^\s@.,!?;:]+/g

/**
 * @param {string} text
 * @returns {boolean}
 */
export function messageHasMention(text) {
  if (typeof text !== 'string' || !text) return false
  MENTION_TOKEN_RE.lastIndex = 0
  return MENTION_TOKEN_RE.test(text)
}

/**
 * @param {string} text
 * @returns {Array<{ type: 'text' | 'mention', value: string }>}
 */
export function splitMessageByMention(text) {
  if (typeof text !== 'string' || !text) return []

  const segments = []
  let lastIndex = 0
  MENTION_TOKEN_RE.lastIndex = 0

  for (const match of text.matchAll(MENTION_TOKEN_RE)) {
    const index = match.index ?? 0
    if (index > lastIndex) {
      segments.push({ type: 'text', value: text.slice(lastIndex, index) })
    }
    segments.push({ type: 'mention', value: match[0] })
    lastIndex = index + match[0].length
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) })
  }

  return segments.length > 0 ? segments : [{ type: 'text', value: text }]
}
